/*
    IMAGE & VIDEO
*/

// Width
var imageVideoWidth = document.getElementById('image-video-width');
imageVideoWidth.addEventListener('change', function(event) {
    window.customStyle[".MessengerFrameMedia"]["width"] = event.target.value + " !important";
    window.styleElement.textContent = window.css.of(window.customStyle);
})

// Height
var imageVideoHeight = document.getElementById('image-video-height');
imageVideoHeight.addEventListener('change', function(event) {
    window.customStyle[".MessengerFrameMedia"]["height"] = event.target.value + " !important";
    window.styleElement.textContent = window.css.of(window.customStyle);
})

// Corner Radius
var cornerRadiusTopL = document.getElementById('corner-radius-topL-image-video');
cornerRadiusTopL.addEventListener('change', function(event) {
    window.customStyle[".MessengerFrameMedia"]["border-top-left-radius"] = event.target.value + " !important";
    window.styleElement.textContent = window.css.of(window.customStyle);
})

var cornerRadiusTopR = document.getElementById('corner-radius-topR-image-video');
cornerRadiusTopR.addEventListener('change', function(event) {
    window.customStyle[".MessengerFrameMedia"]["border-top-right-radius"] = event.target.value + " !important";
    window.styleElement.textContent = window.css.of(window.customStyle);
})

var cornerRadiusBottomR = document.getElementById('corner-radius-bottomR-image-video');
cornerRadiusBottomR.addEventListener('change', function(event) {
    window.customStyle[".MessengerFrameMedia"]["border-bottom-right-radius"] = event.target.value + " !important";
    window.styleElement.textContent = window.css.of(window.customStyle);
})

var cornerRadiusBottomL = document.getElementById('corner-radius-bottomL-image-video');
cornerRadiusBottomL.addEventListener('change', function(event) {
    window.customStyle[".MessengerFrameMedia"]["border-bottom-left-radius"] = event.target.value + " !important";
    window.styleElement.textContent = window.css.of(window.customStyle);
})

// Margin
var marginTop = document.getElementById('margin-top-image-video');
marginTop.addEventListener('change', function(event){
    window.customStyle[".MessengerFrameMedia"]["margin-top"] = event.target.value + " !important";
    window.styleElement.textContent = window.css.of(window.customStyle);
})
var marginBottom = document.getElementById('margin-bottom-image-video');
marginBottom.addEventListener('change', function(event){
    window.customStyle[".MessengerFrameMedia"]["margin-bottom"] = event.target.value + " !important";
    window.styleElement.textContent = window.css.of(window.customStyle);
})
var marginLeft = document.getElementById('margin-left-image-video');
marginLeft.addEventListener('change', function(event){
    window.customStyle[".MessengerFrameMedia"]["margin-left"] = event.target.value + " !important";
    window.styleElement.textContent = window.css.of(window.customStyle);
})
var marginRight = document.getElementById('margin-right-image-video');
marginRight.addEventListener('change', function(event){
    window.customStyle[".MessengerFrameMedia"]["margin-right"] = event.target.value + " !important";
    window.styleElement.textContent = window.css.of(window.customStyle);
})